import { ApplicationFormValueProps } from "../types/CareerInitialProps";

export const CarrerFormData: ApplicationFormValueProps = {
    full_name: "",
    email: "",
    interested_position: "",
    resume: [],
    department: "",
};
